import React from 'react';
import { Spin } from 'antd';
import cn from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';

function Loader({ loading }) {
  return (
    <div
      className={cn('loader', {
        'loader--active': loading,
      })}
    >
      <Spin indicator={<LoadingOutlined />} />
    </div>
  );
}

export default Loader;
